import {createContext} from 'react';

import {Market, ShopLocale} from './types';

export interface ShopLocalesAndMarketsContextProps {
  // Locales
  primaryLocale: ShopLocale;
  currentLocale: ShopLocale;
  locales: ShopLocale[];

  // Markets
  currentMarket?: Market;
  markets: Market[];
}

export const ShopLocalesAndMarketsContext =
  createContext<ShopLocalesAndMarketsContextProps | null>(null);
